export const seo = {
    route: '/',
    name: 'SEO Settings',
    fields: [
        {
            name: 'Homepage Title',
            key: 'seo.homepage_title',
        },
        {
            name: 'Homepage Description',
            key: 'seo.homepage_description',
        },
        {
            name: 'Homepage Tags',
            key: 'seo.homepage_tags',
        },
    ]
};



// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/node_modules/vebto-client/admin/appearance/config/seo-config.ts